import React, {Component} from 'react'
import PropTypes from "prop-types"
import _ from "lodash"
import {Row} from "elemental"
import shop from "../../shop/shop"

class ProductList extends Component {

	constructor( props ) {
		super( props )
		this.state = {
			products: [],
			list    : [],
			ready   : false
		}
	}

	componentWillReceiveProps( props ) {
		if ( props.list !== this.state.list ) {
			this.load( props )
		}
		this.setState( props )
	}

	componentDidMount() {
		this.load( this.props )
	}

	load( props = this.props ) {
		shop.products.list( props.list )
			.then( products => {
				let sorted = this.props.list.map( id => {
					return   _.first(products.filter( p => p.map_id === id ))
				} ).filter(e => e)

				this.setState( {products: sorted, ready: true} )
			} )
	}

	render() {
		let {sm, md, xs, lg, title} = this.props
		const {ready} = this.state
		let Child = this.props.repeat
		let products = this.state.products.map( ( product, key ) => <Child {...{
			sm,
			md,
			xs,
			lg
		}} key={key} product={product} /> )

		const noResults = ready && products.length === 0
		return (
			<div>
				{(title) ? <div className="row-title"><h2>{title}</h2></div> : null}
				{noResults && <div>Keine Produkte gefunden</div>}
				<Row>
					{products}
				</Row>
			</div>
		)
	}
}

ProductList.propTypes = {
	list  : PropTypes.array,
	xs    : PropTypes.string,
	sm    : PropTypes.string,
	md    : PropTypes.string,
	lg    : PropTypes.string,
	title : PropTypes.string,
	repeat: PropTypes.any.isRequired

}

export default ProductList




// WEBPACK FOOTER //
// ./src/components/Product/ProductList.js